<template>
  <li>
    <strong>Publisher:</strong>
    <!-- {{ currentVariant.publisher }} -->
    Publisher TBD
  </li>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'VariantPublisher',
  computed: {
    ...mapState({
      currentVariant: state => state.ProductVariantStore.currentVariant,
    }),
  },
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/VariantPublisher.vue